/**
 * p360 vendor bundle entry.
 * Bundles three.js + Photo Sphere Viewer v5 (core + plugins) into a single
 * IIFE that exposes everything on window.P360Vendor.
 *
 * Rebuild:  cd tools/vendor-build && npm install && npm run build
 */
import '@photo-sphere-viewer/core/index.css';
import '@photo-sphere-viewer/markers-plugin/index.css';
import '@photo-sphere-viewer/gallery-plugin/index.css';
import '@photo-sphere-viewer/compass-plugin/index.css';

import * as THREE from 'three';
import { Viewer, DEFAULTS, utils, events, CONSTANTS } from '@photo-sphere-viewer/core';
import { EquirectangularTilesAdapter } from '@photo-sphere-viewer/equirectangular-tiles-adapter';
import { MarkersPlugin } from '@photo-sphere-viewer/markers-plugin';
import { GalleryPlugin } from '@photo-sphere-viewer/gallery-plugin';
import { CompassPlugin } from '@photo-sphere-viewer/compass-plugin';
import { AutorotatePlugin } from '@photo-sphere-viewer/autorotate-plugin';

export {
    THREE,
    Viewer,
    DEFAULTS,
    utils,
    events,
    CONSTANTS,
    EquirectangularTilesAdapter,
    MarkersPlugin,
    GalleryPlugin,
    CompassPlugin,
    AutorotatePlugin,
};
